import AddToCart from '../../components/form/addToCart';
import SimpleGallery from '../../components/simple-gallery/SimpleGallery';

const productRecommendations = () => {
  const container = document.querySelector('.js-product-recommendations');
  if (!container) {
    return;
  }

  const { baseUrl, productId, sectionId, limit } = container.dataset;
  const recommendationsSectionUrl = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}`;

  fetch(recommendationsSectionUrl)
    .then((res) => res.text())
    .then((section) => {
      container.innerHTML = section;

      // Add to cart forms
      const productForms = container.querySelectorAll('.shopify-product-form');
      productForms.forEach((productForm) => {
        new AddToCart(productForm);
      });
    });
};

// See AddToCart for adding products to Ajax Cart
new SimpleGallery(document.querySelector('.js-simple-gallery'));

// Listen for changes done in the Theme Editor
document.addEventListener('shopify:section:load', (event) => {
  if (event.detail.sectionId === 'product-recommendations') {
    productRecommendations();
  }
});

productRecommendations();
